import { render, staticRenderFns } from "./DomainsTableWrapper.vue?vue&type=template&id=8df204a2"
import script from "./DomainsTableWrapper.vue?vue&type=script&lang=js"
export * from "./DomainsTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./DomainsTableWrapper.vue?vue&type=style&index=0&id=8df204a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports